export default __webpack_public_path__ + "static/media/ic_filter_primary.f74cf69e.svg";